import { render } from "./InsightsNavbar.vue?vue&type=template&id=16bc213e&ts=true"
import script from "./InsightsNavbar.vue?vue&type=script&lang=ts"
export * from "./InsightsNavbar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__